import React from 'react'
import AxesSizeConfig from './editor/AxesSizeConfig'
import i18n from 'live/services/i18n'
import styled, { css } from 'styled-components'
import theme from 'live/services/theme'
import TooltipTypeSelector from 'live/components/widget/config/forms/tooltip'

type ConfigProps = {
    onChange: (field: string, value: unknown) => void
    onChangeLayoutConfig: (field: string, value: unknown) => void
    config: LiveWidgetConfig
    widgetConfig: LiveWidgetConfig
}

const StateTimelineConfigForm: React.FunctionComponent<ConfigProps> = (props: ConfigProps) => {
    const { onChange, onChangeLayoutConfig } = props
    const { numberOfVisibleAxes } = props.config

    const isEditor = true // props.isEditor

    return (
        <Container dark={!isEditor}>
            <TooltipTypeSelector
                {...props}
                config={{ ...props.config, tooltipType: props.config.tooltipOption }}
                onChange={(e, v) => onChange('tooltipOption', v)}
            ></TooltipTypeSelector>
            <AxesSizeConfig
                label={i18n('Size of axes area')}
                value={numberOfVisibleAxes}
                onChange={v => onChangeLayoutConfig('numberOfVisibleAxes', v)}
            />
        </Container>
    )
}

export default StateTimelineConfigForm

const Container = styled.div`
    margin-left: 5px;

    .input-field {
        display: flex;
        border-radius: 3px;

        > input {
            border-color: transparent;
        }
    }

    ${({ dark, isEditor }) =>
        dark && !isEditor
            ? css`
                  h3 {
                      color: #fff;
                  }

                  hr {
                      border-color: 1px solid rgb(40, 51, 74);
                  }

                  .input-config {
                      div {
                          border-color: ${theme['darker-bg']};
                          background-color: ${theme['text-color']};
                      }
                      .input-field {
                          border: 1px solid ${theme['darker-bg']};
                          background-color: ${theme['dark-bg']};
                          color: white;
                      }
                  }

                  .action-toogle > a {
                      background-color: ${theme['dark-bg']};
                  }

                  .input-field > input {
                      -webkit-box-shadow: none;
                      border-radius: 3px;
                      background-color: ${theme['dark-bg']};
                      color: ${theme.white} !important;
                  }
                  .Select-menu-outer {
                      border-color: ${theme['darker-bg']};
                  }
                  .Select-value {
                      background: ${theme['dark-bg']};

                      span.Select-value-label {
                          color: ${theme.white} !important;
                      }
                  }
                  .Select-input {
                      color: ${theme['darker-bg']};
                  }
                  .Select-control,
                  .Select-placeholder {
                      background-color: transparent;
                  }
                  .Select-placeholder {
                      color: lightgray;
                  }
                  .Select-control {
                      border-radius: 3px;
                      background-color: ${theme['dark-bg']};
                      border: solid 1px ${theme['darker-bg']};
                  }
                  .Select.is-open > .Select-control,
                  .Select-control {
                      border-radius: 3px;
                      border-color: ${theme['darker-bg']};
                      background-color: ${theme['dark-bg']};
                  }
                  .Select-option,
                  .Select-noresults {
                      background-color: ${theme['darker-bg']};
                      color: #cdd3e1;
                  }
                  .Select-option.is-focused {
                      background-color: ${theme['main-tipography']};
                      color: white;
                  }
                  .Select-menu-outer {
                      border-color: theme[ 'darker-bg' ];
                  }
                  .Select-menu {
                      &::-webkit-scrollbar {
                          width: 7px;
                          background: #0d1820;
                      }
                      &::-webkit-scrollbar-track {
                          background: #0d1820;
                          border-radius: 0;
                          margin: 1px;
                      }
                      &::-webkit-scrollbar-track-piece {
                          background: #0d1820;
                      }
                      &::-webkit-scrollbar-thumb {
                          background: ${theme['dark-bg']};
                          border-radius: 0;
                          height: 50px;
                          background-clip: padding-box;
                      }
                  }
              `
            : css`
                  .input-field {
                      border: 1px solid ${theme['light-borders']};
                  }
              `}

    .tooltip-toggler {
        margin-bottom: 20px;

        li:first-of-type {
            display: none;
        }
    }
`
